import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import "./ProjectsPage.css";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import NatureIcon from "@mui/icons-material/Nature";
import CakeIcon from "@mui/icons-material/Cake";
import BabyChangingStationIcon from "@mui/icons-material/BabyChangingStation";
import SchoolIcon from "@mui/icons-material/School";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";

interface Project {
  id: number;
  translationKey: string;
  icon: React.ReactNode;
  slug: string;
}

const ProjectsPage: React.FC = () => {
  const { t, getLanguageUrl } = useLanguage();
  const navigate = useNavigate();
  const [showCustomProjectModal, setShowCustomProjectModal] = useState(false);

  const projects: Project[] = [
    {
      id: 1,
      translationKey: "project.cleaning",
      icon: <CleaningServicesIcon />,
      slug: "cleaning",
    },
    {
      id: 2,
      translationKey: "project.tubshvat",
      icon: <NatureIcon />,
      slug: "tubshvat",
    },
    {
      id: 3,
      translationKey: "project.batmitzvah",
      icon: <CakeIcon />,
      slug: "batmitzvah",
    },
    {
      id: 4,
      translationKey: "project.baby",
      icon: <BabyChangingStationIcon />,
      slug: "baby",
    },
    {
      id: 5,
      translationKey: "project.school",
      icon: <SchoolIcon />,
      slug: "school",
    },
    {
      id: 6,
      translationKey: "project.chanukah",
      icon: <CurrencyExchangeIcon />,
      slug: "chanukah",
    },
    {
      id: 7,
      translationKey: "project.hospital",
      icon: <LocalHospitalIcon />,
      slug: "hospital",
    },
    {
      id: 8,
      translationKey: "project.soldiers",
      icon: <MilitaryTechIcon />,
      slug: "soldiers",
    },
  ];

  const handleOpenCustomProjectModal = () => {
    setShowCustomProjectModal(true);
  };

  const handleCloseCustomProjectModal = () => {
    setShowCustomProjectModal(false);
  };

  const handleContactForProject = () => {
    // Close the modal
    setShowCustomProjectModal(false);
    // Navigate to the contact page with language prefix
    navigate(getLanguageUrl("/contact"));
  };

  return (
    <div className="projects-page">
      <h1 className="projects-page-title">{t("our.projects")}</h1>
      <div className="projects-grid">
        {projects.map((project) => (
          <Link
            key={project.id}
            to={getLanguageUrl(`/projects/${project.slug}`)}
            className="project-card"
          >
            <div className="project-icon">{project.icon}</div>
            <h3 className="project-name">{t(project.translationKey)}</h3>
          </Link>
        ))}
      </div>
      {/* Custom Project Button */}
      <div className="create-project-container">
        <button
          className="create-project-button"
          onClick={handleOpenCustomProjectModal}
        >
          <AddCircleIcon className="create-project-icon" />
          {t("create.your.project")}
        </button>
      </div>
      {/* Custom Project Modal */}
      {showCustomProjectModal && (
        <div
          className="custom-project-modal-overlay"
          onClick={handleCloseCustomProjectModal}
        >
          <div
            className="custom-project-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="custom-project-modal-close"
              onClick={handleCloseCustomProjectModal}
              aria-label={t("close.modal")}
            >
              <CloseIcon />
            </button>
            <div className="custom-project-modal-header">
              <h2>{t("your.project")}</h2>
            </div>
            <div className="custom-project-modal-body">
              {t("custom.project.description")}
            </div>
            <div className="custom-project-modal-footer">
              <button
                className="contact-project-button"
                onClick={handleContactForProject}
              >
                <EmailIcon />
                {t("contact.for.project")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectsPage;
